// extracted by mini-css-extract-plugin
export default {"featureSwitch":"FeatureSwitch__featureSwitch__VUBAF"};